<template>
  <div class="notice wrap">
    <div class="title">
      <div class="noticeTitle">通知公告</div>
      <div class="more" @click="goNoteList">更多</div>
    </div>
    <div class="main_nitice">
      <div class="left">
        <img :src="image" alt="" width="520px" height="300px" />
      </div>
      <div class="right">
        <div v-for="(item, i) in noteList" class="rightContent" :key="item.id" @click="goNoteDetail(item)">
          <div class="time">
            <div class="top"><span>{{ getTime(item.sendTime,'MM') }}</span>/{{ getTime(item.sendTime,'DD') }}</div>
            <div class="bottom">{{ getTime(item.sendTime,'YYYY') }}</div>
          </div>
          <div class="news_content">
            <div class="newsTitle">
              {{ item.title }}
            </div>
            <div class="newsContent">
              {{ item.info }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticeImage, getNoticeList } from "@/api/other";
import moment from "moment";
export default {
  name: "notice",
  data() {
    return {
      image: "",
      noteList: [],
    };
  },
  created() {
    this.getNoticeImage();
    this.getNoticeList();
  },
  methods: {
    async getNoticeImage() {
      try {
        const res = await getNoticeImage();
        this.image = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getNoticeList() {
      const params = {
        page: "1",
        limit: "3",
      };
      try {
        const res = await getNoticeList(params);
        this.noteList = res.data;
       
        // console.log(moment(res.data[0].createTime).format('YYYY'));
      } catch (error) {
        console.log(error);
      }
    },
    getTime(time,params){
      return moment(time).format(params)
    },
    goNoteDetail(item){
      let routeData = this.$router.resolve({
        name: "NoticeDetail",
        query:{id:item.id}
      });
      window.open(routeData.href, "_blank");
    },
    goNoteList(){
      let routeData = this.$router.resolve({
        name: "NoticeList",
      });
      window.open(routeData.href, "_blank");
    }
  },
};
</script>
<style scoped lang="scss">
.notice {
  margin-bottom: 20px;
  margin-top: 20px;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: #fff;
    border-bottom: 1px solid #e9e9e9;

    .noticeTitle {
      margin-right: 30px;
      font-size: 16px;
      font-weight: 700;
      color: #558ad6;
    }

    .more {
      color: #558ad6;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .main_nitice {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    .right {
      width: 640px;
      max-height: 300px;

      .rightContent {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 100px;
        padding: 15px 0;
        &:hover .newsTitle {
          color: #558ad6;
        }
      }

      .time {
        width: 44px;
        height: 100%;
        padding-top: 5px;
        .top {
          width: 100%;
          height: 30px;
          font-size: 14px;
          color: #333;
          font-weight: 700;
          border-bottom: 1px solid #999;

          span {
            font-size: 20px !important;
            font-weight: 700;
          }
        }

        .bottom {
          font-size: 12px;
          color: #999;
          padding-top: 5px;
        }
      }

      .news_content {
        width: 580px;
        height: 100%;
      }

      .newsTitle {
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
        font-size: 16px;
        font-weight: 700;
        color: #333;
        cursor: pointer;
      }

      .newsContent {
        margin-top: 10px;
        font-size: 14px !important;
        color: #666 !important;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }
}
// 适配移动端

@media (max-width: 600px) {
  .main_nitice{
   width: 100% !important;
   flex-direction: column !important;
   .left{
    display: flex;
    justify-content: center;
   }
   .right{
    margin: 20px auto;

   }
  //  justify-content: space-between;
  
  }
}
</style>
